import React from 'react';
import { useModal } from '../../../hooks/useModal';

export const Footer = () => {
    return (
            <>
                <div className="hidden footer">
                    <footer>
                    </footer>
                </div>

            </>
    )
}



